import Parallax from './Parallax.vue'

export default {
  Parallax
}



// WEBPACK FOOTER //
// ./src/components/parallax/index.js